/**
 * @desc 알림 관련 API 모음집
 */

import { v2AxiosInstance } from "./indexApi";

/**
 * @desc 알림 목록 조회
 * @returns {Promise<Object>} - 서버 응답 데이터
 */
export const getNotificationAlarm = async () => {
  const { data } = await v2AxiosInstance.get(`/notification`);
  return data;
};

/**
 * @desc 알림 전체 읽기
 * @returns {Promise<Object>} - 서버 응답 데이터
 */
export const postNotificationReadAlarm = async () => {
  const { data } = await v2AxiosInstance.post(`/notification/read`);
  return data;
};
